import { Box, styled } from '@mui/material';
import { IPublicAndPrivateSettings } from '@pepperhq/location-sdk';

import { MuiCardForm } from 'lib/form/MuiCardForm';
import { SwitchFormField } from 'lib/form/fields/SwitchFormField';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { SettingDisplay } from 'lib/SettingDisplay';
import { SettingDisplaySwitch } from '../SettingDisplaySwitch';
import { SettingDisplayText } from '../SettingDisplayText';

const PREFIX = 'AppleGoogleSSOSettingsPrefix';

const classes = {
    settingsCard: `${PREFIX}-settingsCard`,
    displayClassName: `${PREFIX}-displayClassName`
};

const StyledMuiCardForm = styled(MuiCardForm)(({ theme }) => ({
    [`&.${classes.settingsCard}`]: {
        marginBottom: theme.spacing(2)
    },
    [`& .${classes.displayClassName}`]: {
        padding: theme.spacing(2)
    }
}));

type IProp = {
    settings: IPublicAndPrivateSettings;
    onSubmit: (values: Record<string, any>) => Promise<boolean>;
};

export const AppleGoogleSSOSettings = ({ settings, onSubmit }: IProp) => (
    <StyledMuiCardForm
        title="Apple & Google SSO"
        initialValues={{
            appleSSOEnabled: !!settings?.appleSSOEnabled,
            appleSSO_webClientId: settings?.appleSSO?.webClientId,
            googleSSOEnabled: !!settings?.googleSSOEnabled,
            googleSSO_iosClientId: settings?.googleSSO?.iosClientId,
            googleSSO_webClientId: settings?.googleSSO?.webClientId,
            googleSSO_webAppClientId: settings?.googleSSO?.webAppClientId
        }}
        childrenWhileDisplaying={
            <Box display="flex" flexDirection="column">
                <SettingDisplaySwitch title="Apple SSO Enabled" checked={!!settings?.appleSSOEnabled} />
                <SettingDisplayText title="Apple SSO Web Client ID" text={settings?.appleSSO?.webClientId} />
                <SettingDisplaySwitch title="Google SSO Enabled" checked={!!settings?.googleSSOEnabled} />
                <SettingDisplayText
                    title="Google SSO iOS Client ID"
                    text={settings?.googleSSO?.iosClientId}
                    buildtimeIOS
                />
                <SettingDisplayText
                    title="Google SSO Web Client ID"
                    text={settings?.googleSSO?.webClientId}
                />
                <SettingDisplayText
                    title="Google SSO Web App Client ID"
                    text={settings?.googleSSO?.webAppClientId}
                />
            </Box>
        }
        childrenWhileEditing={
            <Box display="flex" flexDirection="column">
                <SettingDisplay label="Apple SSO Enabled">
                    <SwitchFormField name="appleSSOEnabled" />
                </SettingDisplay>
                <SettingDisplay label="Apple SSO Web Client ID">
                    <TextFormField name="appleSSO_webClientId" />
                </SettingDisplay>
                <SettingDisplay label="Google SSO Enabled">
                    <SwitchFormField name="googleSSOEnabled" />
                </SettingDisplay>
                <SettingDisplay label="Google SSO iOS Client ID">
                    <TextFormField name="googleSSO_iosClientId" />
                </SettingDisplay>
                <SettingDisplay label="Google SSO Web Client ID">
                    <TextFormField name="googleSSO_webClientId" />
                </SettingDisplay>
                <SettingDisplay label="Google SSO Web App Client ID">
                    <TextFormField name="googleSSO_webAppClientId" />
                </SettingDisplay>
            </Box>
        }
        onSubmit={onSubmit}
        className={classes.settingsCard}
        boxClassName={classes.displayClassName}
    />
);
